//import _ from 'lodash';
import {
  call,
  put,
  select,
  fork,
  takeLatest
} from 'redux-saga/effects';
import {
  //getFormValues,
  change
} from 'redux-form';
import {
//  cleanJsonInResponse
} from '../../../../../util/helpers';
import {
  SET_DATA,
  OMNI_GET_COMMUNITY,
  OMNI_LOCALIZE,
  GET_SUGGESTIONS,
  SELECT_SUGGESTION
} from './localization';
import loader from '../../../../../util/loader/loader';
import {
  navigationRoutes,
  navigationSteps
} from '../../../navigation/navigationHelpers';
import {
  showGlobalSpinner,
  hideGlobalSpinner,
  errorPageByFlow
} from '../../../common/common';
//import {setSuggestions} from '../../../suggestions/suggestions';

// WATCHERS
export function* omniGetCommunityWatch() {
  yield takeLatest(OMNI_GET_COMMUNITY, omniGetCommunityWorker);
}
export function* omniLocalizeAddressWatch() {
  yield takeLatest(OMNI_LOCALIZE, omniLocalizeAddressWorker);
}
export function* localizeSuggestionsWatch() {
  yield takeLatest(GET_SUGGESTIONS, localizeSuggestionsWorker);
}
export function* selectSuggestionsWatch() {
  yield takeLatest(SELECT_SUGGESTION, selectSuggestionWorker);
}

// WORKERS
export function* omniGetCommunityWorker() {
  try {
    const releaseNotesEndpoint = navigationRoutes[navigationSteps.omni.OMNI_SALES].endpoints.getReleaseNotes();
    const featuresEndpoint = navigationRoutes[navigationSteps.omni.OMNI_SALES].endpoints.getFeatures();
    const issuesEndpoint = navigationRoutes[navigationSteps.omni.OMNI_SALES].endpoints.getIssues();

    const communityCalls = [
      call(loader.request, releaseNotesEndpoint, {useGlobalSpinner: false, redirectOnError: false}),
      call(loader.request, featuresEndpoint, {useGlobalSpinner: false, redirectOnError: false}),
      call(loader.request, issuesEndpoint, {useGlobalSpinner: false, redirectOnError: false})
    ];

    const communityData = yield communityCalls;

    if (communityData && communityData.length > 0) {
      yield put({type: SET_DATA, payload: {
        communityData: {
          releaseNotes: communityData[0],
          features: communityData[1],
          issues: communityData[2]
        }
      }});
    }
  } catch(e) {
    //console.log(e);
  }
}

export function* omniLocalizeAddressWorker() {
  //const state = yield select();
  const errorPage = yield select(errorPageByFlow);
  //const omniLocalizeEndpoint = navigationRoutes[navigationSteps.omni.OMNI_SALES].endpoints.omniLocalize();

  const tenantEncodeEndpoint = navigationRoutes[navigationSteps.omni.OMNI_SALES].endpoints.tentantEncodeToken();

  //const values = getFormValues('omniLocalize')(state); // state.form.movers.fields;
  /*const data = {
    "address": {
      "streetAddress": values.streetAddress,
      "unitNumber": values.unitNumber,
      "zipCode": values.zipCode
    },
  };*/

  const data = {
    "nbf": 1507663696,
    "exp": 2587667296,
    "iat": 1507667296,
    "iss": "Einstein360",
    "ntId": "JPadge001", //need
    "affiliate": "OMNI-TEST",
    "channel": "TELESALES",
    "salesSessionId": "",
    "source": "Einstein360",
    "accountNumber": "",
    "ucid": "",
    "uid": "",
    "avayaAgentId": "",
    "streetAddress1": "",
    "streetAddress2": "",
    "unit": "",
    "unitType": "",
    "city": "",
    "state": "",
    "zip": "",
    "csgSalesRepId": "22185", //need
    "csgOperatorId": "d<{", //need
    "ddpSalesRepId": "", //need
    "ddpOperatorId": "", //need
    "ml0": "",
    "ml1": "",
    "ml2": "",
    "ml3": "",
    "ml4": "",
    "ml5": ""
  };

  try {

    yield put(showGlobalSpinner({hideContent: false, initiator: 'calling moveCustomer'}));
    const tenantToken = yield call(loader.request, tenantEncodeEndpoint, {data, useGlobalSpinner: false, redirectOnError: false, errorPage});

    window.location.href = `https://www.stg.xfinity.com/learn/tenant/onboarding?token=${tenantToken}`;
  } catch(e) {
    yield put(hideGlobalSpinner());
    //console.log(e);
  }
}

export function* localizeSuggestionsWorker() {
  /*const errorPage = yield select(errorPageByFlow);
  const localizeSuggestionsEndpoint = navigationRoutes[navigationSteps.omni.OMNI_SALES].endpoints.getSuggestions(action.payload.search);

  try {
    const localizeSuggestions = yield call(loader.request, localizeSuggestionsEndpoint, {useGlobalSpinner: false, withCredentials: true, redirectOnError: false, errorPage});
    const cleanPropsFromResponse = cleanJsonInResponse(localizeSuggestions.data); //Learn team uses capitals in thier props

    yield put(setSuggestions('localizeSuggestions', cleanPropsFromResponse));
  } catch(e) {
    // console.log(e);
  }*/
}

export function* selectSuggestionWorker(action) {
  const address = action.payload.suggestion.address,
        streetAddress = address.address_StreetAddress || '',
        unitNumber = address.address_UnitNumber || '',
        zipCode = address.address_ZipCode || '';

  yield put(change('movers', 'streetAddress', streetAddress));
  yield put(change('movers', 'unitNumber', unitNumber));
  yield put(change('movers', 'zipCode', zipCode));
}

export default function* omniLocalizationSagas() {
  yield [
    fork(omniGetCommunityWatch),
    fork(omniLocalizeAddressWatch),
    fork(localizeSuggestionsWatch),
    fork(selectSuggestionsWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Omni/omniSales/localizationSagas.js
 **/